var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHoTestimonial2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.068 5.348C8.588 5.18 8.216 4.904 7.952 4.52C7.688 4.136 7.556 3.668 7.556 3.116C7.556 2.396 7.784 1.808 8.24 1.352C8.696 0.896001 9.26 0.668001 9.932 0.668001C10.628 0.668001 11.204 0.896001 11.66 1.352C12.116 1.832 12.344 2.42 12.344 3.116C12.344 3.452 12.308 3.788 12.236 4.124C12.14 4.484 11.96 5 11.696 5.672L10.004 10.712L7.736 10.712L9.068 5.348ZM2.264 5.348C1.784 5.18 1.412 4.904 1.148 4.52C0.884 4.136 0.752 3.668 0.752 3.116C0.752 2.396 0.980001 1.808 1.436 1.352C1.892 0.896 2.456 0.668 3.128 0.668C3.824 0.668 4.4 0.896 4.856 1.352C5.312 1.832 5.54 2.42 5.54 3.116C5.54 3.452 5.504 3.788 5.432 4.124C5.336 4.484 5.156 5 4.892 5.672L3.2 10.712L0.932001 10.712L2.264 5.348Z",
    fill: "#CB202D",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoTestimonial2);
export default __webpack_public_path__ + "static/media/HoTestimonial2.7af6d4a1c48b0ea36388192f7c131e13.svg";
export { ForwardRef as ReactComponent };